/// <reference path="irep.js"/>

/*
Drawer js is to be used with the following handlebars template

    <script id="drawertemplate" type="text/x-handlebars-template">
        <div id="drawercontainer">
            <div id="drawercurtain"></div>
            <div id="drawercontent">
                <div id="drawerloader">
                    <img src="<%= AppSettings.AppRoot %>Content/images/Loader.gif" alt="Loader" />
                </div>
                <div id="drawerclose">
                   <img src="<%= AppSettings.AppRoot %>Content/images/Nav/Close_CCCCCC.png" />
                </div>
            </div>
        </div>
    </script>


Options needed to init:

template: handlebars template
animateOnInit: defines whether the drawer will begin animating before data has loaded
getUrl: defines the url to call $.get from
drawerColor: defines the color for drawer current options are blue, grey
useOverlay: boolean to define weather or not we're going to show the overlay with this drawer
animatePosition: defines whether we want the drawer to animate from the bottom of the page or float inline with
    the content, current options are bottom and float
*/

IREP.drawer = (function () {

    var options;
    var defaults = {
        template: null,
        getUrl: null,
        drawerColor: "blue",
        useOverlay: false,
        animatePosition: "bottom",
        animateOnInit: true,
        closeDrawer: null,
        doneCallback: null
};

    var init = function (drawerOptions) {
        options = $.extend({}, defaults, drawerOptions);

        if (options.animateOnInit) {
            if (options.animatePosition == "float") {
                animateFloating();
            } else {
                animateBottom();
            }
        }
        if (options.useOverlay) {
            addOverlay();
        }

        getData();
        options.template.find($("#drawerclose")).on("click", hideDrawer);
    };
    var animateBottom = function() {
        var position = options.template.position();
        options.template.find($("#drawercurtain")).filter(':not(:animated)').animate({
            height: "0px"
        }, 400);
    };

    var animateFloating = function () {
        var position = options.template.position();
        options.template.find($("#drawercurtain")).filter(':not(:animated)').animate({
            height: "0px"
        }, 400);

        if ((position.top + 440) === document.height) {
            $("html, body").animate({
                scrollTop: $(document).height() - $(window).height()
            },
                700);
        } else {
            $("html, body").animate({
                scrollTop: (position.top + 440) - $(window).height()
            },
            700);
        }
    };

    var hideDrawer = function () {
        if ($.isFunction(options.closeDrawer)) {
            options.closeDrawer();
        } else {
            options.template.fadeOut(400, function () {
                $(this).remove();
            });

            if (options.useOverlay) {
                $("#overlay").fadeOut(400, function () { $(this).remove(); });
            }
        }
    };

    var doneCallback = function() {
        if ($.isFunction(options.doneCallback)) {
            options.doneCallback();
        } else {
            return;
        }
    };

    var getData = function () {
        $.get(options.getUrl, function (html) {
            var results = $("<div>").append(html);
            results.css("opacity", "0");
            options.template.find("#drawercontent").append(results);
            results.animate({ opacity: "1" }, 200);
        }).done(function () {
            doneCallback();
            options.template.find($("#drawerloader").css("display", "none"));
        });
    };

    var addOverlay = function () {
        $("<div id='overlay'>")
            .addClass("overlay")
            .appendTo(options.template.parent());
    };

    return {
        init: init,
        show: animateBottom,
        hide: hideDrawer
};
})();


